import React from "react";
import {authRoles} from "app/auth/index.js";

import i18next from "../../../i18n.js";

import en from "./i18n/en.js";
import fr from "./i18n/fr.js";

i18next.addResourceBundle("en", "collection", en);
i18next.addResourceBundle("fr", "collection", fr);

const CollectionConfig = {
  settings: {layout: {config: {}}},
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: "/collection",
      exact: true,
      component: React.lazy(() => import("./Collections.js")),
    },
    {
      path: "/collection/:id",
      exact: true,
      component: React.lazy(() => import("../mycollection/Collection.js")),
    },
  ],
};

export default CollectionConfig;
